export default "__VITE_ASSET__Dwl6XQYe__"